import { fetchApi } from '@/config/axiosSetting.ts';
import { EntryTabsQueryResponseType } from '@/modules/FileDetail/queries/entryTabs/entryTabsQuery.type.ts';

export const entryTabsQueryFunction = (
  id: string,
): Promise<EntryTabsQueryResponseType[]> =>
  fetchApi.get(`/my_files/${id}/file_entry_tabs/`);
